import axios from 'axios'
import router from './router'

let config = {};

//let url  = "http://140.210.93.91:8088/";

//let url  = "http://localhost:8081/";
let url =  process.env.URL ;

config = {
   baseURL:  url+'api/',
   // timeout: 5000
 };


 // axios 实例
const ajaxObj = axios.create(config);

// http request(请求) 拦截器
ajaxObj.interceptors.request.use(
  config => {
    let accessToken = window.localStorage.getItem('access_token');
   // accessToken='eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ0ZWFjaGVyMSIsImV4cCI6MTY0Mzc3OTczNSwiaWF0IjoxNjQzMTc5NzM1LCJqdGkiOjh9.JJSNlC3ggFjUD9MWimInlu9gQ2Sy0SoMOMJqUUbqMn2lGKYauBDHAslGLBhSXG0tEtzyEwc3jiIHiUDko7qKeg'
    
    config.headers.Authorization = `Bearer ${accessToken}`;
    
    return config;
  },
  err => {
    console.log('请求错误信息', err);
    return Promise.reject(err);
  }
);

import { Message } from 'element-ui';

ajaxObj.interceptors.response.use(
  response => {
    return response;
  },
  function (error) {
    if(error.response.status ==406 ){
        
      const message_conf = {
        showClose: true,
        message: '您请按照任务顺序学习！',
        type: 'error',
        duration: 2000
     }
     Message(message_conf)
    
    }
    console.log(error.response)
    if(error.response.status ==400 ){
        
      const message_conf = {
        showClose: true,
        message: error.response.data.msg,
        type: 'error',
        duration: 2000
     }
      Message(message_conf)
    
    }

   return Promise.reject(error);
  });


export default ajaxObj;


// WEBPACK FOOTER //
// ./src/ajax.js